import { getPaymentIntent, getPayoutMethod } from "../../services/api";
import { formatPaymentResponse, formatPayoutResponse } from "./utils";

export const sdkGetIntentDetails = async ({
  intentType,
  intentId,
  lang,
}: {
  intentId: string;
  lang: string;
  intentType: "payment" | "payout";
}) => {
  if (intentType === "payment") {
    return formatPaymentResponse(await getPaymentIntent(intentId, lang));
  }

  return formatPayoutResponse(await getPayoutMethod(intentId, lang));
};
